import { gql } from "@apollo/client";

const GET_FINALIST = gql`
  query ($juries_id: ID!, $finalists_id: ID!) {
    rating(juries_id: $juries_id, finalists_id: $finalists_id) {
      rating_1
      rating_2
      rating_3
      is_skipped
      total
    }
    finalist(id: $finalists_id) {
      name
    }
  }
`;

const SET_FINALIST_RATING = gql`
  mutation (
    $juries_id: ID!
    $finalists_id: ID!
    $is_skipped: Boolean
    $rating_1: Float
    $rating_2: Float
    $rating_3: Float
    $total: Float
  ) {
    setFinalistRating(
      juries_id: $juries_id
      finalists_id: $finalists_id
      is_skipped: $is_skipped
      rating_1: $rating_1
      rating_2: $rating_2
      rating_3: $rating_3
      total: $total
    )
  }
`;

const SET_FINISHED_FINALISTS_RESULTS = gql`
  mutation {
    setFinishedFinalistsResults
  }
`;

const SET_JURIES_LOCKED = gql`
  mutation ($id: ID!) {
    setUserLocked(id: $id)
  }
`;

const SET_FINALISTS_FINISHED = gql`
  mutation ($juries_id: ID!) {
    setFinalistsFinished(juries_id: $juries_id)
  }
`;

const GET_FINALISTS_RATINGS = gql`
  query ($juries_id: ID!) {
    ratings(juries_id: $juries_id) {
      finalists_id
      is_skipped
      total
    }
    finalists {
      id
      name
      library
    }
  }
`;

const GET_FINALISTS_RATINGS_IN_JURIES_CARD = gql`
  query ($juries_id: ID!) {
    user(id: $juries_id) {
      login
    }
    ratings(juries_id: $juries_id) {
      finalists_id
      is_skipped
      total
    }
    finalists {
      id
      name
      library
    }
  }
`;

const GET_JURIES = gql`
  query {
    users {
      id
      login
      is_locked
      is_admin
    }
  }
`;

const GET_FINALISTS = gql`
  query {
    finalists {
      id
      name
      library
      stage_1
      stage_2
      stage_3
      total
    }
  }
`;

const SUB_FINALIST = gql`
  subscription {
    finalistUpdate {
      id
      stage_3
      total
    }
  }
`;

const SUB_JURIES = gql`
  subscription {
    userUpdate {
      id
      is_locked
    }
  }
`;

const SIGN_IN = gql`
  mutation ($id: ID!, $password: String!) {
    signIn(id: $id, password: $password) {
      user_token
      is_admin
      is_locked
    }
  }
`;

export {
  SET_FINALIST_RATING,
  SET_FINALISTS_FINISHED,
  SET_FINISHED_FINALISTS_RESULTS,
  SET_JURIES_LOCKED,
  GET_FINALIST,
  GET_FINALISTS_RATINGS,
  GET_FINALISTS,
  GET_JURIES,
  GET_FINALISTS_RATINGS_IN_JURIES_CARD,
  SUB_FINALIST,
  SUB_JURIES,
  SIGN_IN,
};
